export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	async registerUser(state: any, payload: any) {
		await this.$axios.get('sanctum/csrf-cookie');
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/register', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateUser(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/user/information', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updatePassword(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/user/password', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
